import React from "react";
import withStyles from "components/common/wrappers/withStyles";

const CreditMonitoring = ({ color = "white", svgClassname }) => {
  return (
    <svg
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={svgClassname}
    >
      <g clipPath="url(#clip0_130_6405)">
        <path
          d="M3.33331 8.00002C3.33331 5.42269 5.42265 3.33335 7.99998 3.33335M10.9999 5.00002L7.99991 8.00002M14.6666 8.00002C14.6666 11.6819 11.6818 14.6667 7.99998 14.6667C4.31808 14.6667 1.33331 11.6819 1.33331 8.00002C1.33331 4.31812 4.31808 1.33335 7.99998 1.33335C11.6818 1.33335 14.6666 4.31812 14.6666 8.00002ZM8.66665 8.00002C8.66665 8.36822 8.36818 8.66669 7.99998 8.66669C7.63178 8.66669 7.33331 8.36822 7.33331 8.00002C7.33331 7.63182 7.63178 7.33335 7.99998 7.33335C8.36818 7.33335 8.66665 7.63182 8.66665 8.00002Z"
          stroke={color}
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_130_6405">
          <rect width="16" height="16" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};

export default withStyles(CreditMonitoring);
